export default __webpack_public_path__ + "static/media/information.d60e89a3.svg";